// extracted by mini-css-extract-plugin
export default {"title":"CampaignsTable_title__yOpEI","surveyColumn":"CampaignsTable_surveyColumn__9Rh7E","columntitle":"CampaignsTable_columntitle__f+5hk"};